import { Component, Input } from '@angular/core';
import { CollectsSnapshotResponse } from '../../../../services/collects-analytics/collects-analytics.model';

@Component({
    selector: 'app-collects-kpi-cards',
    templateUrl: './collects-kpi-cards.component.html',
    styleUrls: ['./collects-kpi-cards.component.scss'],
})
export class CollectsKpiCardsComponent {
    @Input() snapshot: CollectsSnapshotResponse;
    @Input() comparePrevious = false;

    get viewsDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.totalViews?.previousValue === undefined) return null;
        return this.snapshot.totalViews.value - this.snapshot.totalViews.previousValue;
    }

    get viewersDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.uniqueViewers?.previousValue === undefined) return null;
        return this.snapshot.uniqueViewers.value - this.snapshot.uniqueViewers.previousValue;
    }

    get downloadsDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.totalDownloads?.previousValue === undefined) return null;
        return this.snapshot.totalDownloads.value - this.snapshot.totalDownloads.previousValue;
    }

    get downloadRateDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.downloadRate?.previousValue === undefined) return null;
        return +(this.snapshot.downloadRate.value - this.snapshot.downloadRate.previousValue).toFixed(1);
    }

    get engagementRate(): number | null {
        if (!this.snapshot?.registeredUsers || this.snapshot.registeredUsers === 0) return null;
        return +((this.snapshot.uniqueViewers.value / this.snapshot.registeredUsers) * 100).toFixed(1);
    }
}
